export enum AccountStatusReasonsEnum {
  GAMBLING_ISSUES = 'GamblingIssues',
  FRAUD = 'Fraud',
  DUPLICATE_ACCOUNT = 'DuplicateAccount',
  PLAYER_REQUEST = 'PlayerRequest',
  FAILED_LOGIN_ATTEMPTS = 'FailedLoginAttempts',
  FAILED_KYC = 'FailedKYC',
  FAILED_AML = 'FailedAML',
  OTHER = 'Other',
}
